import { Routes as RouteTypes } from 'types/routeTypes';

/**
 * Opening the brand settings on ONE brand (Steven, 23 Sep 2026).
 *
 * The video wizard's "set your brand colour" link used to land on the list of
 * every brand, all closed, and the customer had to know which one the campaign
 * uses. The link now names the brand and the settings page opens it.
 */
export const BRAND_QUERY_KEY = 'brand';

/** The brand settings, with this brand open. No id: the plain list. */
export const brandSettingsHref = (brandId?: number | null): string =>
  brandId
    ? `${RouteTypes.BRAND_SETTINGS}?${BRAND_QUERY_KEY}=${brandId}`
    : RouteTypes.BRAND_SETTINGS;

/** The brand the address asks for, or null. */
export const brandIdFromSearch = (search: string): number | null => {
  const raw = new URLSearchParams(search).get(BRAND_QUERY_KEY);
  const id = raw === null ? NaN : Number(raw);
  return Number.isInteger(id) && id > 0 ? id : null;
};
